
import modals from '../modal'

class VideoButton {
  constructor(button) {

    console.log('button')

    this.playBtn = button

    this.handlePlayBtnClick = this.handlePlayBtnClick.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
  }

  handlePlayBtnClick(event) {
    const embedData = JSON.parse(this.playBtn.dataset.embed)
    this.fullVideoContainer.innerHTML = embedData.embed

    this.modal.open(this.playBtn)
  }

  handleModalClose() {
    // Clear out the currently playing embed
    this.fullVideoContainer.innerHTML = ''
  }

  init() {
    this.fullVideoContainer = document.getElementById('video-full-embed')
    this.modal = modals.getById('modal-video')
    this.modal.element.addEventListener('close', this.handleModalClose)

    this.playBtn.addEventListener('click', this.handlePlayBtnClick)
  }
}

export default VideoButton;
